// removed by extract-text-webpack-plugin
module.exports = {"ObjectNav":"styles__ObjectNav___2t3bx","ObjectNavInner":"styles__ObjectNavInner___1dLev","ObjectNavBtns":"styles__ObjectNavBtns___1CnWa","ObjectNavBtn":"styles__ObjectNavBtn___18G8I","Active":"styles__Active___tZv_z","UpdatedTime":"styles__UpdatedTime___3aROD","Hide1180":"styles__Hide1180___1tWtc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Nav/styles.scss
// module id = 1301
// module chunks = 0